import { paymentMethodsByCountry, type Country } from '../entities/Country';
import type { PaymentMethodType } from '../entities/enums';
import type { Feature } from '../types';

const convertFeatureKeyToPaymentMethod = (
  paymentMethod: PaymentMethodType,
): keyof Feature => {
  switch (paymentMethod) {
    case 'CreditCard':
      return 'creditcard';
    case 'Fpx':
      return 'fpx';
    case 'IdVirtualAccount':
      return 'idVirtualAccount';
    case 'IdOnlineBanking':
      return 'idOnlineBanking';
    case 'IdEWallet':
      return 'idEWallet';
    case 'PhOnlineBanking':
      return 'phOnlineBanking';
    case 'PhEWallet':
      return 'phEWallet';
    case 'ThOnlineBanking':
      return 'thOnlineBanking';
    case 'PayNowQR':
      return 'paynowqr';
    case 'Cheque':
      return 'cheque';
    case 'Invoice':
      return 'invoice';
    case 'IdQr':
      return 'idQRIS';
    case 'PromptPay':
      return 'promptPay';
    case 'HkEWallet':
      return 'hkEWallet';
    case 'PayPal':
      return 'paypal';
    case 'HkFps':
      return 'hkFps';
    case 'PhBnpl':
      return 'phBnpl';
  }
};

export const getPaymentMethods = (
  country: Country,
  features: Record<string, boolean> | Feature,
): PaymentMethodType[] => {
  const paymentMethods: PaymentMethodType[] = [];

  if (country in paymentMethodsByCountry) {
    const methodsForCountry = paymentMethodsByCountry[country];
    for (const paymentMethod of methodsForCountry) {
      const paymentMethodFeature =
        convertFeatureKeyToPaymentMethod(paymentMethod);
      if (features[paymentMethodFeature]) {
        paymentMethods.push(paymentMethod);
      }
    }
  }

  return paymentMethods;
};
